import { ErrorResponse, RequestException } from './exceptions';

export default class RequestExceptionWithResponse extends RequestException {
    constructor(response: Response, errorResponse: ErrorResponse) {
        super(response);

        this.code = errorResponse.code;
        this.rcid = errorResponse.requestCorrelationId ? errorResponse.requestCorrelationId.value : undefined;
        this.errorName = errorResponse.name;
        this.developerMessage = errorResponse.developerMessage;
        this.type = errorResponse.type;
        this.message = errorResponse.message;
    }
}

/**
 RequestExceptionWithResponse {
    name: 'RequestExceptionWithResponse',
    status: 400,
    url: '/test',
    code: 'INF4570001',
    rcid: '1234-1234-1234-12345',
    errorName: 'MANGLER_BANKREGNR',
    developerMessage: 'stacktrace fra java',
    type: 'BAD_REQUEST'
 }
 */
